<template>
    <div class="wrapper" data-lang="ua">
        <Header />
        <div class="main">
            <slot />
        </div>
        <Footer />
    </div>
</template>

<script setup>
import { ref } from "vue";

const isMobileMenuOpen = ref(false);
const isCartPopupOpen = ref(false);

const toggleMobileMenu = () => {
    isMobileMenuOpen.value = !isMobileMenuOpen.value;
};

const toggleCartPopup = () => {
    isCartPopupOpen.value = !isCartPopupOpen.value;
};
</script>
